

export function initMatomo() {
/*  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);

  (function() {
    var u = 'http://ebusradar.localhost/wp-content/plugins/matomo/app/';
    //_paq.push(['setTrackerUrl', u + 'matomo.php']);
    //_paq.push(['setSiteId', '1']);

    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type='text/javascript'; g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
  })();*/
}

export function matomoTrackEvent(category, action, params = null) {
  
  console.log('_paq', window._paq);
  if (window._paq) {

    const language = document.querySelector('html').getAttribute('lang').substring(0, 2);
    
    if (params) {
      params['language'] = language;
    }
    else {
      params = {
        language: language,
      };
    }

    console.log(['trackEvent', category, action, JSON.stringify(params)]);
    window._paq.push(['trackEvent', category, action, JSON.stringify(params)]);
  }
}
